import React from 'react';
import dropin from 'braintree-web-drop-in';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Typography
} from '@mui/material';
import { withStyles } from '@mui/styles';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomText from 'components/common/CustomText/CustomText';

const useStyles = () => ({
  root: {
    width: '100%'
  },
  subscribeButton: {
    width: '100%'
  },
  buttonContainer: {
    display: 'flex'
  }
});

class Payment extends React.Component {
  dropinInstance = null;
  dropinContainerRef = React.createRef();

  state = {
    showAlert: false,
    alertMessage: '',
    messageType: '',
    isBuying: false
  };

  componentDidMount() {
    if (!this.props.clientToken) return;

    dropin.create(
      {
        authorization: this.props.clientToken,
        container: this.dropinContainerRef.current,
        paypal: {
          flow: 'vault',
          buttonStyle: {
            color: 'blue',
            shape: 'rect',
            size: 'medium'
          }
        },
        card: {
          vault: {
            vaultCard: true,
            allowVaultCardOverride: true
          }
        },
        // dataCollector: true // enable only if fraud tools are active
      },
      (err, instance) => {
        if (err) {
          this.setState({
            showAlert: true,
            alertMessage: err.message,
            messageType: 'error'
          });
          return;
        }

        this.dropinInstance = instance;
      }
    );
  }

  componentWillUnmount() {
    if (this.dropinInstance) {
      this.dropinInstance.teardown();
      this.dropinInstance = null;
    }
  }

  buy = async () => {
    try {
      this.setState({ isBuying: true });

      if (!this.dropinInstance) {
        throw new Error('Payment UI not ready');
      }

      const { nonce } = await this.dropinInstance.requestPaymentMethod();
      this.props.setPaymentMethod(nonce);

      this.setState({ isBuying: false });
    } catch (err) {
      this.setState({
        isBuying: false,
        showAlert: true,
        alertMessage: err.message || 'Payment failed',
        messageType: 'error'
      });

      setTimeout(() => {
        this.setState({ showAlert: false });
      }, 2000);
    }
  }

  render() {
    const { classes } = this.props;
    const { showAlert, alertMessage, messageType, isBuying } = this.state;

    return (
      <div className={classes.root}>
        <Snackbar open={showAlert}>
          <Alert
            // onClose={() => this.setState({ showAlert: false })}
            severity={messageType}
          >
            {alertMessage}
          </Alert>
        </Snackbar>

        <CustomText text='Choose your method of payment' />

        {/* Braintree Drop-in mounts here */}
        <div ref={this.dropinContainerRef} />

        <Box my={2} justifyContent="center" className={classes.buttonContainer}>
          <CustomButton
            text={'Subscribe'}
            fullWidth
            onClick={this.buy}
            loading={isBuying || this.props.isCreating || this.props.isUpdating}
          />
        </Box>
      </div>
    );
  }
}

export default withStyles(useStyles)(Payment);
